import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App.jsx'
import { AuthProvider } from './contexts/AuthContext.jsx'
import { SiteSettingsProvider } from './contexts/SiteSettingsContext.jsx'
import { AudioPlayerProvider } from './hooks/useAudioPlayer.jsx'
import './index.css'

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <BrowserRouter>
      <SiteSettingsProvider>
        <AuthProvider>
          <AudioPlayerProvider>
            <App />
          </AudioPlayerProvider>
        </AuthProvider>
      </SiteSettingsProvider>
    </BrowserRouter>
  </StrictMode>
)
